import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ ]
  static values = {
    reverse: { type: Boolean, default: false },
    valuable: { type: Boolean, default: false }
  };

  sortBy(event) {
    const th = event.target.closest('th') || event.target
    const tr = th.closest('tr')
    const table = tr.closest('table')
    const idx = Array.from(tr.children).indexOf(th)

    const isNumeric = th.classList.contains('numeric')
    const isDate = th.classList.contains('date')

    let dir = this.reverseValue ? "desc" : "asc"

    if (th.classList.contains("asc")) dir = "desc"
    else if (th.classList.contains("desc")) dir = "asc"

    this.sortTable(table, idx, isNumeric, isDate, dir)
    this.updateHeaderClasses(tr, th, dir)
  }

  sortTable(table, idx, isNumeric, isDate, dir) {
    const tbody = table.querySelector('tbody') || table
    const rowsArray = Array.from(tbody.querySelectorAll('tr')).filter(row => !row.querySelector('th'))

    rowsArray.sort((rowA, rowB) => {
      const cellA = rowA.children[idx]
      const cellB = rowB.children[idx]

      if (!cellA || !cellB) return 0

      let valA, valB

      if (isNumeric) {
        valA = parseFloat(cellA.innerText.replace(/[^\d.]/g, "")) || 0
        valB = parseFloat(cellB.innerText.replace(/[^\d.]/g, "")) || 0
      } else if (isDate) {
        const strA = this.valuableValue ? cellA.dataset.value : cellA.innerText
        const strB = this.valuableValue ? cellB.dataset.value : cellB.innerText
        valA = this.convertDotDateToJSDate(strA || '').getTime()
        valB = this.convertDotDateToJSDate(strB || '').getTime()
      } else {
        valA = cellA.innerText.toLowerCase()
        valB = cellB.innerText.toLowerCase()
      }

      if (valA < valB) return dir === "asc" ? -1 : 1
      if (valA > valB) return dir === "asc" ? 1 : -1
      return 0
    })

    const fragment = document.createDocumentFragment()
    rowsArray.forEach(row => fragment.appendChild(row))
    tbody.appendChild(fragment)
  }

  updateHeaderClasses(headerRow, activeTh, dir) {
    Array.from(headerRow.getElementsByTagName("th")).forEach(th => {
      if (th === activeTh) {
        th.classList.toggle("asc", dir === "asc")
        th.classList.toggle("desc", dir === "desc")
      } else {
        th.classList.remove("asc", "desc")
      }
    })
  }

  convertDotDateToJSDate(string) {
    const trimmed = string.trim()
    if (!trimmed || trimmed === "—") {
      return new Date(2200, 0, 1) // Январь — это 0 в JS
    }
    const parts = trimmed.split('.')
    if (parts.length !== 3) return new Date(1970, 0, 1)

    const day = parseInt(parts[0], 10)
    const month = parseInt(parts[1], 10) - 1
    const year = parseInt(parts[2], 10)

    return new Date(year, month, day)
  }
}
